import { render, staticRenderFns } from "./EmployeeSettings.vue?vue&type=template&id=3a436573"
import script from "./EmployeeSettings.vue?vue&type=script&lang=js"
export * from "./EmployeeSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports